export function requireGuidePortal(portalID) {
    if (!portalID?.trim() || portalID === '_')
        throw new Error('portalID is required for guide/cluster reads');
    return portalID;
}
export function guideRowInPortal(row, organizationID, portalID) {
    return row?.organizationID === organizationID && row.portalID === portalID;
}
/** AppSync limits evaluated rows, not matching rows. Drain empty filtered pages too. */
export async function listGuidePortalRows(readPage, organizationID, portalID, cap) {
    requireGuidePortal(portalID);
    const items = [];
    let nextToken;
    do {
        const page = await readPage(nextToken);
        for (const row of page?.items ?? []) {
            if (guideRowInPortal(row, organizationID, portalID))
                items.push(row);
        }
        nextToken = page?.nextToken || undefined;
    } while (nextToken && items.length < cap);
    return items.slice(0, cap);
}
//# sourceMappingURL=GuidePortalQueries.js.map